import {matchPath} from 'react-router';
import ChatTab from '../ChatTab';
import {Paths} from '../../../routes/Paths/Paths';

export default function getInitialChatTab(): ChatTab {
  const path = location.pathname;

  if (matchPath(Paths.ChannelsMenu, path) || matchPath(Paths.ChatFull, path)) {
    return ChatTab.CHATS;
  }

  return ChatTab.SETTINGS;
}
